/* Calix — add-to-cart motion, shared by the product grid, quick view and cart page.
   CalixCart.fly(fromEl, imgSrc, done) — product thumbnail arcs into the header bag
   CalixCart.setCount(n)               — updates the header count bubble (and pops it)
   CalixCart.bump()                    — small bounce on the bag icon
   Respects prefers-reduced-motion. */
(function () {
  if (window.CalixCart) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css =
    '#cart-icon-bubble.cx-bump{animation:cxBag 520ms cubic-bezier(.34,1.56,.64,1)}' +
    '@keyframes cxBag{0%{transform:scale(1)}35%{transform:scale(1.2)}100%{transform:scale(1)}}' +
    '#cart-icon-bubble .cart-count-bubble.cx-pop{animation:cxBubble 460ms cubic-bezier(.34,1.56,.64,1)}' +
    '@keyframes cxBubble{0%{transform:scale(.3)}60%{transform:scale(1.3)}100%{transform:scale(1)}}' +
    '.cx-fly{position:fixed;z-index:60000;pointer-events:none;width:56px;height:70px;margin:0;' +
    'object-fit:cover;background:#F2F0EB;box-shadow:0 10px 24px -10px rgba(10,10,10,.35);will-change:transform,opacity}' +
    '@media (prefers-reduced-motion:reduce){#cart-icon-bubble.cx-bump,#cart-icon-bubble .cart-count-bubble.cx-pop{animation:none}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function bag() { return document.getElementById('cart-icon-bubble'); }
  function restart(el, cls) { el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }

  function bump() {
    var b = bag();
    if (b && !reduce) restart(b, 'cx-bump');
  }

  function setCount(n) {
    var b = bag();
    if (!b) return;
    n = parseInt(n, 10) || 0;
    var bubble = b.querySelector('.cart-count-bubble');
    if (n <= 0) { if (bubble) bubble.remove(); return; }
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      b.appendChild(bubble);
    }
    bubble.innerHTML =
      '<span aria-hidden="true">' + (n < 100 ? n : '99+') + '</span>' +
      '<span class="visually-hidden">' + n + (n === 1 ? ' item' : ' items') + '</span>';
    if (!reduce) restart(bubble, 'cx-pop');
    bump();
  }

  function fly(fromEl, src, done) {
    var b = bag();
    var finish = function () { if (done) done(); };
    if (!b || !fromEl || reduce || !Element.prototype.animate) { finish(); return; }
    /* The sticky header hides while scrolling down — slide it back in first
       so the product has somewhere to land. */
    var header = document.querySelector('.shopify-section-header-hidden');
    if (header && header.contains(b)) {
      header.classList.remove('shopify-section-header-hidden');
      header.classList.add('animate');
      setTimeout(function () { launch(b, fromEl, src, finish); }, 280);
      return;
    }
    launch(b, fromEl, src, finish);
  }

  function launch(b, fromEl, src, finish) {
    var to = b.getBoundingClientRect();
    var from = fromEl.getBoundingClientRect();
    if (to.width === 0 || to.bottom < 0 || to.top > window.innerHeight) { finish(); return; }

    var w = 56, h = 70;
    var el;
    if (src) { el = new Image(); el.src = src; el.alt = ''; }
    else { el = document.createElement('span'); }
    el.className = 'cx-fly';
    el.setAttribute('aria-hidden', 'true');
    var sx = from.left + from.width / 2 - w / 2;
    var sy = from.top + from.height / 2 - h / 2;
    el.style.left = sx + 'px';
    el.style.top = sy + 'px';
    document.body.appendChild(el);

    var dx = to.left + to.width / 2 - (sx + w / 2);
    var dy = to.top + to.height / 2 - (sy + h / 2);
    var anim = el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.4 + 'px,' + (dy * 0.4 - 70) + 'px) scale(.75)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.18)', opacity: 0.15 }
    ], { duration: 720, easing: 'cubic-bezier(.5,0,.3,1)' });
    anim.onfinish = function () { el.remove(); finish(); };
  }

  window.CalixCart = { fly: fly, setCount: setCount, bump: bump };

  /* ---- Product grid "+" and quick-view "Add to cart" ----
     Those scripts write the new count straight into #cart-icon-bubble, which
     wipes the bag icon. Here we remember where the add came from, put the
     icon back, fly the product into the bag, then show the new count. */
  var lastSource = null;

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('[data-quick-add-form]')) {
      var card = f.closest('.calix-card');
      var img = card && card.querySelector('.calix-card__media img');
      lastSource = { el: img || f, src: img ? (img.currentSrc || img.src) : '', t: Date.now() };
    } else if (f.id === 'calix-qv-form') {
      var gallery = document.getElementById('calix-qv-gallery');
      var imgs = document.querySelectorAll('#calix-qv-track img');
      var dots = document.querySelectorAll('#calix-qv-dots .calix-qv-dot');
      var i = 0;
      dots.forEach(function (d, k) { if (d.classList.contains('active')) i = k; });
      var shot = imgs[i] || imgs[0];
      lastSource = { el: gallery || f, src: shot ? (shot.currentSrc || shot.src) : '', t: Date.now() };
    }
  }, true);

  function added(n, prev) {
    var src = lastSource;
    lastSource = null;
    /* Only fly when the count really went up (not when stock ran out). */
    if (src && n > prev && Date.now() - src.t < 8000) {
      fly(src.el, src.src, function () { setCount(n); });
    } else {
      setCount(n);
    }
  }

  function watch() {
    var b = bag();
    if (!b || b.getAttribute('data-cx-watch')) return;
    b.setAttribute('data-cx-watch', '1');
    var saved = b.innerHTML;
    new MutationObserver(function () {
      if (b.querySelector('svg')) { saved = b.innerHTML; return; }
      var n = parseInt(b.textContent, 10);
      b.innerHTML = saved;
      var shown = b.querySelector('.cart-count-bubble span');
      var prev = shown ? (parseInt(shown.textContent, 10) || 0) : 0;
      if (!isNaN(n)) added(n, prev);
    }).observe(b, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
